module.exports = __webpack_public_path__ + "img/home-bg.8585ce6f.png";